<template>
  <!--  begin feature section  -->
  <section class="bg-white feature">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <div class="feature-content text-center">
            <div class="feature-icon-box">
              <div class="feature-icon center-block">
                <i class="fa fa-laptop"></i>
              </div>
            </div>
            <!--  end of /.feature-icon-box  -->
            <div class="feature-info">
              <h3 class="feature-heading">Soluções completas</h3>
              <p class="feature-description">
                Do desenvolvimento ao suporte: sistemas, sites, APIs e
                automações sob medida para o seu negócio crescer.
              </p>
              <!--   end of /.feature-description  -->
            </div>
            <!--   end of /.feature-info  -->
          </div>
          <!--  end of /.feature-content  -->
        </div>

        <div class="col-md-3">
          <div class="feature-content text-center">
            <div class="feature-icon-box">
              <div class="feature-icon center-block">
                <i class="fa fa-eye"></i>
              </div>
            </div>
            <!--  end of /.feature-icon-box  -->
            <div class="feature-info">
              <h3 class="feature-heading">Design moderno</h3>
              <p class="feature-description">
                Interfaces bonitas, responsivas e funcionais que valorizam a
                identidade da sua marca e encantam o usuário.
              </p>
              <!--   end of /.feature-description  -->
            </div>
            <!--   end of /.feature-info  -->
          </div>
          <!--  end of /.feature-content  -->
        </div>

        <div class="col-md-3">
          <div class="feature-content text-center">
            <div class="feature-icon-box">
              <div class="feature-icon center-block">
                <i class="fa fa-thumbs-o-up"></i>
              </div>
            </div>
            <!--  end of /.feature-icon-box  -->
            <div class="feature-info">
              <h3 class="feature-heading">Experiência do usuário</h3>
              <p class="feature-description">
                Navegação intuitiva e usabilidade pensada para gerar engajamento
                e resultados reais para o seu projeto.
              </p>
              <!--   end of /.feature-description  -->
            </div>
            <!--   end of /.feature-info  -->
          </div>
          <!--  end of /.feature-content  -->
        </div>

        <div class="col-md-3">
          <div class="feature-content text-center">
            <div class="feature-icon-box">
              <div class="feature-icon center-block">
                <i class="fa fa-star"></i>
              </div>
            </div>
            <!--  end of /.feature-icon-box  -->
            <div class="feature-info">
              <h3 class="feature-heading">Alta satisfação</h3>
              <p class="feature-description">
                Atendimento próximo, entregas ágeis e resultados consistentes
                que geram confiança e fidelidade dos nossos clientes.
              </p>
              <!--   end of /.feature-description  -->
            </div>
            <!--   end of /.feature-info  -->
          </div>
          <!--  end of /.feature-content  -->
        </div>
      </div>
    </div>
    <!-- end of /.container -->
  </section>
  <!--   end of feature section  -->
</template>

<script>
export default {
  name: "FeatureSection",
};
</script>
